A unique resource identifier the position profile.

- For posted position profiles, this is the public web URL of the posted job ad.

- For unposted position profiles, this is the profile's object identifier.
